import * as React from 'react';
import classnames from 'classnames';

import CampaignEntityAvatar from 'components/entity/entity-avatar/CampaignEntityAvatar';
import CampaignEntityName from 'components/entity/entity-name/CampaignEntityName';
import DeliverableTypeCounters from 'modules/deliverables/components/deliverable-type-counters/DeliverableTypeCounters';
import CampaignHistoryOfferState from 'modules/influencers/components/history/campaign-history-offer-state/CampaignHistoryOfferState';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { renderPrice } from 'utils/helper/price';
import { __t, applyTranslations } from 'utils/language';

import type { InfluencerCampaignHistoryItem } from 'types';

applyTranslations(require('./campaign-history-card-preview.i18n.json'));

type Props = {
  item: InfluencerCampaignHistoryItem,
  disabled?: boolean,
  hideCcmCard: boolean,
  toggleButtonDirection: 'top' | 'bottom',
  onClick: (event: React.SyntheticEvent<HTMLSpanElement>) => void
};

class CampaignHistoryCardPreview extends React.PureComponent<Props> {
  renderDraft(): React.ReactNode {
    const { item, disabled } = this.props;

    return (
      <div className="campaign-history-card-preview campaign-history-card-preview--draft">
        <div className="campaign-history-card-preview__main">
          <div className="campaign-history-card-preview__campaign">
            <CampaignEntityAvatar
              campaign={item.campaign}
              disabled={disabled}
              form="square"
              size="customSize"
              customSize={{
                width: 40,
                height: 40
              }}
            />
            <CampaignEntityName
              campaign={item.campaign}
              disabled={disabled}
            />
          </div>
        </div>
        <div className="campaign-history-card-preview__offer">
          <CampaignHistoryOfferState
            item={item}
          />
        </div>
      </div>
    );
  }
  render(): React.ReactNode {
    const { item, toggleButtonDirection, onClick, disabled, hideCcmCard } = this.props;
    const { campaign, deliverables, offer } = item;
    const isDraft = offer.state === 'draft';

    if (hideCcmCard) {
      return null;
    }

    if (isDraft) {
      return this.renderDraft();
    }

    const hasDeliverables = deliverables.length > 0;

    const toggleClasses = classnames({
      'campaign-history-card-preview__toggle-button': true,
      'campaign-history-card-preview__toggle-button--opened': toggleButtonDirection === 'top'
    });

    const deliverablesClasses = classnames({
      'campaign-history-card-preview__deliverables': true,
      'campaign-history-card-preview__deliverables--disabled': !hasDeliverables
    });

    return (
      <div className="campaign-history-card-preview">
        <div className={toggleClasses}>
          <SVGDynamicIcon
            name="chevron-down-custom-fg"
            width={15}
            height={9}
            onClick={onClick}
          />
        </div>
        <div className="campaign-history-card-preview__main">
          <div className="campaign-history-card-preview__campaign">
            <CampaignEntityAvatar
              campaign={campaign}
              disabled={disabled}
              form="square"
              size="customSize"
              customSize={{
                width: 40,
                height: 40
              }}
            />
            <CampaignEntityName
              campaign={campaign}
              disabled={disabled}
            />
          </div>
          <span>
            {__t(`campaign_history_card_preview.campaign_state_${campaign.state}`)}
          </span>
        </div>
        <div className={deliverablesClasses}>
          <div className="campaign-history-card-preview__information-subset">
            <span className="campaign-history-card-preview__label">
              {__t('campaign_history_card_preview.deliverables_label')}:
            </span>
            {
              hasDeliverables ?
                <DeliverableTypeCounters deliverables={deliverables} /> :
                <span>-</span>
            }
          </div>
        </div>
        <div className="campaign-history-card-preview__offer">
          <div className="campaign-history-card-preview__information-subset">
            <span className="campaign-history-card-preview__label">
              {__t('campaign_history_card_preview.offer_label')}:
            </span>
            <span>{renderPrice(offer.value, { separateThousands: false })}</span>
          </div>
          <CampaignHistoryOfferState
            item={item}
          />
        </div>
      </div>
    );
  }
}

export default CampaignHistoryCardPreview;
